const func = ($target) => {
	$('.reject-report-btn').on('click',function() {
		$('.form-pid').val($(this).attr('data-pid'));
	});

	$('#reject-report-modal').on('hide.bs.modal',function(){
		$('.form-pid').val("");
		$('#report-reject-comment').val('');
	})
	
	$('.accept-report-btn').on('click',function(){
		$('.form-pid').val($(this).attr('data-pid'));
	})
};

export default func;
